import PlayerWebRtc from './PlayerWebRtc'
import PlayerMse from './PlayerMse'
import './style.scss'

interface BasicPlayerProps {
  camera: basic.CameraData
}

const Player: React.FC<BasicPlayerProps> = ({ camera }) => {
  switch (camera.type) {
    case 'mse': return <PlayerMse url={camera.url} />
    case 'webrtc': return <PlayerWebRtc url={camera.url} />
    default: return <p>Undefined camera</p>
  }
}

export default Player